import { createBrowserRouter } from "react-router-dom";
import { RootLayout } from "@/layouts/RootLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Solutions from "@/pages/Solutions";
import SolutionDetail from "@/pages/SolutionDetail";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import Portfolio from "@/pages/Portfolio";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Process from "@/pages/Process";
import Technologies from "@/pages/Technologies";
import About from "@/pages/About";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

/**
 * Central route registry.
 *
 * Pages are imported eagerly — for a content-light marketing site this yields
 * instant client-side navigation and avoids Suspense fallback flashes. The
 * layout still wraps everything in a Suspense boundary, so switching any page
 * to `React.lazy` later is a one-line change with zero other refactoring.
 * Adding a page = one import + one entry here + one file in `pages/`.
 */
export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "services", element: <Services /> },
      { path: "services/:slug", element: <ServiceDetail /> },
      { path: "solutions", element: <Solutions /> },
      { path: "solutions/:slug", element: <SolutionDetail /> },
      { path: "industries", element: <Industries /> },
      { path: "industries/:slug", element: <IndustryDetail /> },
      { path: "portfolio", element: <Portfolio /> },
      { path: "case-studies", element: <CaseStudies /> },
      { path: "case-studies/:slug", element: <CaseStudyDetail /> },
      { path: "process", element: <Process /> },
      { path: "technologies", element: <Technologies /> },
      { path: "about", element: <About /> },
      { path: "insights", element: <Insights /> },
      { path: "insights/:slug", element: <InsightDetail /> },
      { path: "contact", element: <Contact /> },
      { path: "faq", element: <FAQ /> },
      { path: "privacy", element: <Privacy /> },
      { path: "terms", element: <Terms /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
